module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "orange_bar"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@img/logo3.png"),
      "alt": "",
      "width": "60"
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "company"
  }, [_c('dt', {
    staticClass: "clearfix concact_us"
  }, [_c('div', [_c('h4', [_vm._v("LET'S BE FRIENDS")]), _vm._v(" "), _c('ul', {
    staticClass: "icon_list clearfix"
  }, [_c('li', [_c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/51TalkHelloWorldAA/",
      "target": "_blank"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://twitter.com/51TalkHWAA",
      "target": "_blank"
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('h4', [_vm._v("CONTACT US")]), _vm._v(" "), _c('ul', {
    staticClass: "concact_type has_l_border"
  }, [_c('li', {
    staticClass: "p27"
  }, [_vm._v("teach@51talk.com")])])])]), _vm._v(" "), _c('dd', [_c('p', [_vm._v("51Talk English International, Inc. 2017 All Rights Reserved")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2394c0f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/public/footer.vue
// module id = 826
// module chunks = 1